import { render, staticRenderFns } from "./FilterByFaultTypes.vue?vue&type=template&id=4c5ecb48"
import script from "./FilterByFaultTypes.vue?vue&type=script&lang=js"
export * from "./FilterByFaultTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports